module.exports = __webpack_public_path__ + "img/logo.af4ce003.png";